export default __webpack_public_path__ + "static/media/supportChatCrossIcon.655736f6.svg";